// extracted by mini-css-extract-plugin
export default {"listContainer":"Bookmarks_listContainer__hzMC2","bookmarkItemContainer":"Bookmarks_bookmarkItemContainer__V-4ZD","bookmarkItemImage":"Bookmarks_bookmarkItemImage__F7CWF"};